import { GridItemRoot, GridRoot } from "./Grid.styled";

export const Grid = props => <GridRoot {...props} />;

export const GridItem = props => <GridItemRoot {...props} />;
